import { render, staticRenderFns } from "./PendingPayment.vue?vue&type=template&id=722830a7&scoped=true"
import script from "./PendingPayment.vue?vue&type=script&lang=js"
export * from "./PendingPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722830a7",
  null
  
)

export default component.exports